import { Component, OnInit } from '@angular/core';
import { Router } from '@angular/router';
import { AuthService } from '../auth/auth-services/auth.service';

@Component({
  selector: 'app-back-office',
  templateUrl: './back-office.component.html',
  styleUrls: ['./back-office.component.scss']
})
export class BackOfficeComponent implements OnInit {

    constructor(private authService: AuthService, private router: Router) { }

    ngOnInit(): void {
    }

    /**
     * Déconnecter l'utilisateur quand il clique sur le bouton.
     * et le rediriger vers la home page.
     */
    onDeconection() {
        this.authService.signOutUser();
        this.router.navigate(["/"]);
    }
}
